var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import React from "react";
import { MyCustomerBL } from "./MyCustomerBL";
import { formatAmount } from "../../shared/Utilites";
import { SharedFunctions } from "../SharedFunctions";
import { ST_CustName_TableCell, ST_Product_Image_CSS } from "../../css/NavigationObjectCss";
import ImageIcon from "@mui/icons-material/Image";
var MobileViewCustomerTable = function (props) {
    var tableType = props.tableType, headerArray = props.headerArray, dataArray = props.dataArray, getProductData = props.getProductData;
    //tableType=1 -> order and 2-> product
    var _a = MyCustomerBL(), shopCurrency = _a.shopCurrency, currency = _a.currency, t = _a.t;
    var getDateFormat = SharedFunctions().getDateFormat;
    var getDynamicTableCellForOrder = function (headerIndex, item) {
        var returnCell;
        switch (headerIndex) {
            case 0:
                returnCell = (_jsx(TableCell, __assign({ sx: __assign(__assign({}, ST_CustName_TableCell), { padding: "8px !important" }), onClick: function () { return getProductData(item); } }, { children: item.order_number })));
                break;
            case 1:
                returnCell = _jsx(TableCell, { children: getDateFormat(item === null || item === void 0 ? void 0 : item.created_at) });
                break;
            case 2:
                returnCell = _jsx(TableCell, { children: item.financial_status || "-" });
                break;
            case 3:
                returnCell = _jsx(TableCell, { children: item.fulfillment_status || "-" });
                break;
            case 4:
                returnCell = _jsx(TableCell, __assign({ className: "ST_White_Space" }, { children: formatAmount(item.subtotal_price, currency, shopCurrency) }));
                break;
            case 5:
                returnCell = _jsx(TableCell, __assign({ className: "ST_White_Space" }, { children: formatAmount(item.shippingCharges || 0, currency, shopCurrency) }));
                break;
            case 6:
                returnCell = _jsx(TableCell, __assign({ className: "ST_White_Space" }, { children: formatAmount(item.total_tax || 0, currency, shopCurrency) }));
                break;
            case 7:
                returnCell = _jsx(TableCell, __assign({ className: "ST_White_Space" }, { children: formatAmount(item.total_price, currency, shopCurrency) }));
                break;
        }
        return returnCell;
    };
    var getDynamicTableCellForProduct = function (headerIndex, item) {
        var returnCell;
        switch (headerIndex) {
            case 0:
                returnCell = _jsx(TableCell, { children: (item === null || item === void 0 ? void 0 : item.Image) ? _jsx(Box, { component: "img", sx: ST_Product_Image_CSS, src: item === null || item === void 0 ? void 0 : item.Image }) : _jsx(ImageIcon, { sx: { height: 50, width: 50 } }) });
                break;
            case 1:
                returnCell = _jsx(TableCell, { children: (item === null || item === void 0 ? void 0 : item.Title) || "-" });
                break;
            case 2:
                returnCell = _jsx(TableCell, { children: (item === null || item === void 0 ? void 0 : item.variantTitle) || "-" });
                break;
            case 3:
                returnCell = _jsx(TableCell, { children: (item === null || item === void 0 ? void 0 : item.SKU) || "-" });
                break;
            case 4:
                returnCell = _jsx(TableCell, { children: (item === null || item === void 0 ? void 0 : item.quantity) || "-" });
                break;
            case 5:
                returnCell = _jsx(TableCell, __assign({ className: "ST_White_Space" }, { children: formatAmount((item === null || item === void 0 ? void 0 : item.ItemPrice) || 0, currency, shopCurrency) }));
                break;
            case 6:
                returnCell = _jsx(TableCell, __assign({ className: "ST_White_Space" }, { children: formatAmount((item === null || item === void 0 ? void 0 : item.discountedPrice) || 0, currency, shopCurrency) }));
                break;
            case 7:
                returnCell = _jsx(TableCell, __assign({ className: "ST_White_Space" }, { children: (item === null || item === void 0 ? void 0 : item.trackingNumber) || "-" }));
                break;
            case 8:
                returnCell = _jsx(TableCell, { children: getDateFormat(item === null || item === void 0 ? void 0 : item.ShipDate) });
                break;
            case 9:
                returnCell = _jsx(TableCell, __assign({ className: "ST_White_Space" }, { children: formatAmount((item === null || item === void 0 ? void 0 : item.Subtotal) || 0, currency, shopCurrency) }));
                break;
        }
        return returnCell;
    };
    var orderCountPopUp = function () {
        var tableStructure = (_jsx(TableContainer, __assign({ sx: { borderRadius: "0px !important" } }, { children: _jsx(Table, { children: dataArray !== null && dataArray !== undefined && (dataArray === null || dataArray === void 0 ? void 0 : dataArray.length) > 0 ? (dataArray === null || dataArray === void 0 ? void 0 : dataArray.map(function (item, index) { return (_jsxs(_Fragment, { children: [_jsx(TableBody, __assign({ sx: { backgroundColor: "whitesmoke" } }, { children: _jsx(React.Fragment, { children: headerArray === null || headerArray === void 0 ? void 0 : headerArray.map(function (header, headerIndex) { return (_jsxs(TableRow, __assign({ className: "MobileViewTableCell" }, { children: [_jsx(TableCell, { children: _jsxs("b", { children: [header === null || header === void 0 ? void 0 : header.label, " :"] }) }), getDynamicTableCellForOrder(headerIndex, item)] }), header.label + headerIndex)); }) }, index) })), _jsx("br", {})] })); })) : (_jsx(TableBody, { children: _jsx(TableRow, { children: _jsx(TableCell, __assign({ className: "BorderBottom" }, { children: t("no_orders_to_show") })) }) })) }) })));
        return tableStructure;
    };
    var productDetailPopup = function () {
        var tableStructure = (_jsx(TableContainer, __assign({ sx: { borderRadius: "0px !important" } }, { children: _jsx(Table, { children: dataArray !== null && dataArray !== undefined && (dataArray === null || dataArray === void 0 ? void 0 : dataArray.length) > 0 ? (dataArray === null || dataArray === void 0 ? void 0 : dataArray.map(function (item, index) { return (_jsxs(_Fragment, { children: [_jsx(TableBody, __assign({ sx: { backgroundColor: "whitesmoke" } }, { children: _jsx(React.Fragment, { children: headerArray === null || headerArray === void 0 ? void 0 : headerArray.map(function (header, headerIndex) { return (_jsxs(TableRow, __assign({ className: "MobileViewTableCell" }, { children: [_jsx(TableCell, { children: _jsxs("b", { children: [header.label, " :"] }) }), getDynamicTableCellForProduct(headerIndex, item)] }), header.label + headerIndex)); }) }, index) })), _jsx("br", {})] })); })) : (_jsx(TableBody, { children: _jsx(TableRow, { children: _jsx(TableCell, __assign({ className: "BorderBottom" }, { children: t("no_product_details") })) }) })) }) })));
        return tableStructure;
    };
    return tableType === "1" ? orderCountPopUp() : productDetailPopup();
};
export default MobileViewCustomerTable;
